export interface FruitType {
  id: number
  name: string
  radius: number
  color: string
  borderColor: string
  emoji: string
  score: number
  nextType: number | null
}

export const FRUITS: FruitType[] = [
  {
    id: 0,
    name: 'Pea Pod',
    radius: 15,
    color: '#7cb342',
    borderColor: '#558b2f',
    emoji: '🫛',
    score: 1,
    nextType: 1,
  },
  {
    id: 1,
    name: 'Tomato',
    radius: 20,
    color: '#e53935',
    borderColor: '#c62828',
    emoji: '🍅',
    score: 3,
    nextType: 2,
  },
  {
    id: 2,
    name: 'Garlic',
    radius: 28,
    color: '#f5f5f5',
    borderColor: '#e0e0e0',
    emoji: '🧄',
    score: 6,
    nextType: 3,
  },
  {
    id: 3,
    name: 'Onion',
    radius: 35,
    color: '#fff59d',
    borderColor: '#f9a825',
    emoji: '🧅',
    score: 10,
    nextType: 4,
  },
  {
    id: 4,
    name: 'Potato',
    radius: 42,
    color: '#c9a66b',
    borderColor: '#a1784e',
    emoji: '🥔',
    score: 15,
    nextType: 5,
  },
  {
    id: 5,
    name: 'Carrot',
    radius: 48,
    color: '#ff9800',
    borderColor: '#e65100',
    emoji: '🥕',
    score: 21,
    nextType: 6,
  },
  {
    id: 6,
    name: 'Bell Pepper',
    radius: 55,
    color: '#ff7043',
    borderColor: '#e64a19',
    emoji: '🫑',
    score: 28,
    nextType: 7,
  },
  {
    id: 7,
    name: 'Eggplant',
    radius: 62,
    color: '#7b1fa2',
    borderColor: '#4a148c',
    emoji: '🍆',
    score: 36,
    nextType: 8,
  },
  {
    id: 8,
    name: 'Broccoli',
    radius: 70,
    color: '#81c784',
    borderColor: '#4caf50',
    emoji: '🥦',
    score: 45,
    nextType: 9,
  },
  {
    id: 9,
    name: 'Lettuce',
    radius: 78,
    color: '#a5d6a7',
    borderColor: '#66bb6a',
    emoji: '🥬',
    score: 55,
    nextType: 10,
  },
  {
    id: 10,
    name: 'Pumpkin',
    radius: 88,
    color: '#ff9800',
    borderColor: '#e65100',
    emoji: '🎃',
    score: 100,
    nextType: null,
  },
]

export function getFruitType(id: number): FruitType {
  return FRUITS[id]
}

export function getNextFruitType(currentId: number): FruitType | null {
  const current = FRUITS[currentId]
  if (current.nextType === null) return null
  return FRUITS[current.nextType]
}

// Only spawn small fruits (first 5) for the drop queue
export const SPAWNABLE_FRUIT_IDS = [0, 1, 2, 3, 4]

export function getRandomSpawnableFruit(): FruitType {
  const randomIndex = Math.floor(Math.random() * SPAWNABLE_FRUIT_IDS.length)
  return FRUITS[SPAWNABLE_FRUIT_IDS[randomIndex]]
}
